module.exports = __webpack_public_path__ + "media/images/horses/Purina-Animal-Nutrition-Purina-Enrich.png";